import { env } from '@/config/env';

export function getProfilePictureUrl(email: string | null | undefined): string | null {
  const normalizedEmail = email?.trim().toLowerCase();
  if (!normalizedEmail) return null;

  if (env.VITE_PROFILES_API?.includes('{0}')) {
    return env.VITE_PROFILES_API.replace('{0}', encodeURIComponent(normalizedEmail));
  }

  if (!env.VITE_PROFILES_API_BASE_URL || !env.VITE_PROFILES_API_KEY) return null;
  return `${env.VITE_PROFILES_API_BASE_URL}?size=standard&apikey=${env.VITE_PROFILES_API_KEY}&search=${normalizedEmail}`;
}
